/**
 * Whether a pathname is the SRP (locale root or jobs listing with optional filters).
 * Mirrors layout SRP detection — keep in sync with LayoutDefault / URL rewrites.
 */
export function isSearchPagePathname(path: string): boolean {
  const segments = String(path).split('/').filter(Boolean);
  if (segments.length === 0) return true;

  const [first, second] = [segments[0], segments[1]];
  const isLocale = ['en', 'fi', 'sv'].includes(first);

  if (isLocale && segments.length === 1) return true;

  const jobsSegments = { en: 'jobs', fi: 'tyopaikat', sv: 'jobb' } as const;
  if (isLocale) {
    const expected = jobsSegments[first as keyof typeof jobsSegments];
    if (second === expected || (first === 'sv' && second === 'lediga-jobb')) return true;
  }

  const allJobSegments = ['jobs', 'tyopaikat', 'jobb'];
  if (segments.length >= 1 && allJobSegments.includes(first)) return true;

  return false;
}
